<template>
  <b-card class="no-border mt-3" no-body>
    <company-table />
  </b-card>
</template>
<script>
import CompanyTable from '@/components/CompanyTable.vue';

export default {
  name: 'company_list',
  components: {
    CompanyTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'companies', name: 'Companies' },
    ]);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/admin/companies/List.vue